import { PartnerSettingValue } from '@provision/entity-types';
import { useMemo } from 'react';
import { isSettingsEnabled, useGroupRules, usePartnerSettings } from 'src/graphql';
import { EntityRulesData, RULES_MAP_PER_VIEW_ENTITY } from 'src/graphql/entities/custom-view';
import { EntityNames } from 'src/graphql/types';
import { useGlobalStore } from 'src/store';

const TABS: ({
  label: string;
  entity: EntityNames;
  enabled?: boolean;
} & EntityRulesData)[] = [
  {
    label: 'Conversations',
    entity: EntityNames.Conversation,
  },
  {
    label: 'Sites',
    entity: EntityNames.Site,
  },
  {
    label: 'Clients',
    entity: EntityNames.Client,
  },
  {
    label: 'Projects',
    entity: EntityNames.Project,
  },
].map((i) => ({ ...i, ...RULES_MAP_PER_VIEW_ENTITY[i.entity] }));

export const useSearchTabs = () => {
  const selectedPartnerId = useGlobalStore.use.selectedPartnerId();

  const { data: partnerSettings } = usePartnerSettings({ partnerId: selectedPartnerId });
  const { loading, checkValidity } = useGroupRules();

  const tabs = useMemo(() => {
    if (loading) return [];

    return TABS.filter(({ allowedRules, disallowedPartnerSettings }) => {
      const rulesMatch = !allowedRules || checkValidity(allowedRules);

      if (!rulesMatch) {
        return false;
      }

      const settingsDisallowMatch =
        disallowedPartnerSettings?.some((settingId) =>
          partnerSettings.some((data) =>
            isSettingsEnabled(settingId, data as PartnerSettingValue),
          ),
        ) ?? false;

      return !settingsDisallowMatch;
    });
  }, [checkValidity, loading, partnerSettings]);

  return { tabs, loading };
};
